import React from 'react';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  color?: 'orange' | 'gray' | 'white';
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'md',
  color = 'orange',
}) => {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
  };

  const colorClasses = {
    orange: 'border-orange-500',
    gray: 'border-gray-500',
    white: 'border-white',
  };

  return (
    <div
      className={`inline-block animate-spin rounded-full border-2 border-solid border-t-transparent ${sizeClasses[size]} ${colorClasses[color]}`}
    />
  );
};
